import { useHookCacheContext } from "./HookCacheProvider";

/**
 * Friendlier alias of {@link useHookCacheContext} for mutation handlers that
 * want direct access to `setEntry` / `invalidate` / `getEntry` without
 * subscribing the calling component to a specific entry.
 */
export const useHookCache = useHookCacheContext;
